import 'jquery';
import 'slick-carousel';

(function ($) {
  $(document).ready(($) => {
    /**
     * Init slick slider
     */
    setImmediate(() => {
      $('.wp-block-gallery .blocks-gallery-grid').each(function () {
        /**
         * The current slick slider
         * @type {jQuery|HTMLElement}
         */
        const $slickElement = $(this);

        /**
         * Status counter of the slider
         * @type {jQuery|HTMLElement}
         */
        const $statusText = $('<div class="counter"/>');

        /**
         * Cursor with mix-blend mode
         * @type {jQuery|HTMLElement}
         */
        const $cursor = $('<div class="cursor"/>')

        // add counter (number at the bottom of the slider)
        $slickElement.on('init', function () {
          $(this).append($statusText);
          $(this).append($cursor);
        });

        // populate counter
        $slickElement.on('init reInit afterChange', function (event, slick, currentSlide) {
          //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          const i = (currentSlide ? currentSlide : 0) + 1;
          $statusText.text(i + '/' + slick.slideCount);
        });

        // init slick
        $slickElement.slick({
          arrows: false,
          adaptiveHeight: false,
        });
      });
    });

    /**
     * add slider nav with arrows or destroy it
     */
    function slickNavigation() {
      if ($(window).width() < 960) { // why not on 768px, when the menu collapses?
        $('.wp-block-gallery').each(function () {
          const $element = $(this);
          // remove event listener
          $element.off('mousemove');
          $element.off('click');
          $element.removeClass('west', 'east');
        });
      } else {
        $('.wp-block-gallery').each(function () {
          const $element = $(this);
          $('img', $element).each(function() {
            const $img = $(this)
            let border = $img.width() / 2;
            // maybe image not fully loaded yet
            $img.on('load', () => {
               border = $img.width() / 2;
            });
            $img.on('mousemove', (e) => {
              // move cursor
              $('.cursor', $element).css({"top": e.offsetY, "left": e.offsetX });
              if (e.offsetX < border) {
                $element.addClass('west').removeClass('east');
              } else {
                $element.addClass('east').removeClass('west');
              }
            });
            // hide cursor
            $img.on('mouseleave', () => {
              $('.cursor', $element).hide()
            });
            // show cursor
            $img.on('mouseenter', () => {
              $('.cursor', $element).show()
            });
            // Add click event for slider
            $img.on('click', (e) => {
              if (e.offsetX < border) {
                $element.find('.blocks-gallery-grid').slick('slickPrev');
              } else {
                $element.find('.blocks-gallery-grid').slick('slickNext');
              }
            });

          })
        });
      }
    }

    //  resize listener
    $(window).on('resize', () => {
      // check if we need slick navigation
      slickNavigation();
      // reposition slider
      if ($(window).width() > 960) { // why not on 768px, when the menu collapses?
        $('.wp-block-gallery .blocks-gallery-grid').each(function () {
          if ($(this).hasClass('slick-initialized')) {
            $(this).slick('setPosition');
          }
        });
      }
    });

    // init slick navigation
    slickNavigation();
  });
})(jQuery)
